// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es6.array.is-array.js
// module id = 211
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11